import Masthead from '@components/Masthead';
import { useTranslation } from 'react-i18next';
import { useStoreState } from 'easy-peasy';
import { jobStoreSelector } from '@model/Job/Job.selectors';

export const SuccessFeeHeader = () => {
  const { t } = useTranslation();
  const job = useStoreState(jobStoreSelector);

  return (
    <Masthead
      full
      isBackToJobAvailable
      job={job}
      title={t('hero.prospect.title')}
    />
  );
};
